import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyDeliveryNoteStatusBar, { BuyDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../BuyDeliveryNoteStatusBar'
import BuyDeliveryNoteCreateNoPermissionButtons, { BuyDeliveryNoteCreateNoPermissionButtonsNew } from '../BuyDeliveryNoteCreateNoPermissionButtons'

type BuyDeliveryNoteCreateNoPermissionsStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyDeliveryNoteCreateNoPermissionsStepHeaderDecider: React.FC<BuyDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyDeliveryNoteCreateNoPermissionsStepHeaderDefault} NewComponent={BuyDeliveryNoteCreateNoPermissionsStepHeaderNew} {...rest} />
    )
}

const BuyDeliveryNoteCreateNoPermissionsStepHeaderDefault: React.FC<BuyDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyDeliveryNoteStatusBar {...rest} />
            <BuyDeliveryNoteCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const BuyDeliveryNoteCreateNoPermissionsStepHeaderNew: React.FC<BuyDeliveryNoteCreateNoPermissionsStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyDeliveryNoteStatusBarNew {...rest} />
            <BuyDeliveryNoteCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyDeliveryNoteCreateNoPermissionsStepHeaderDecider